import type { FC } from "react";
import { OwnHomeColdIntro } from "web_myplann/Inspiration/Components/OwnHomeColdIntro";
import { OwnHomeRatesUnavailable } from "web_myplann/Inspiration/Components/OwnHomeRatesUnavailable";
import { OwnHomeResult } from "web_myplann/Inspiration/Components/OwnHomeResult";
import type { OwnHomeContext } from "web_myplann/Inspiration/Utils/ownHomeMath";

type Props = {
	context: OwnHomeContext | null;
	isLoading: boolean;
	onEditAffordability: () => void;
	onAddExpenses: () => void;
};

export const OwnHomeContent: FC<Props> = ({
	context,
	isLoading,
	onEditAffordability,
	onAddExpenses,
}) => {
	if (isLoading) return <OwnHomeColdIntro rates={null} />;

	if (!context) return <OwnHomeRatesUnavailable />;

	if (context.state === "cold")
		return <OwnHomeColdIntro rates={context.rates} />;

	return (
		<OwnHomeResult
			context={context}
			onEditAffordability={onEditAffordability}
			onAddExpenses={onAddExpenses}
		/>
	);
};
